import { render, staticRenderFns } from "./WorkBookCongratulations.vue?vue&type=template&id=ad0f6c58&scoped=true&"
import script from "./WorkBookCongratulations.vue?vue&type=script&lang=js&"
export * from "./WorkBookCongratulations.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookCongratulations.vue?vue&type=style&index=0&id=ad0f6c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0f6c58",
  null
  
)

export default component.exports